import { isMasterContext, useAuth } from '@/features/auth';
import { navigation } from '@/navigation';

export interface CreditBillingPaths {
  /** The billing page of the current context. */
  billing: string;
  /** The credit statement of the current context. */
  transactions: string;
}

/** Billing and statement paths: the board's under `/master-account`, an account's elsewhere. */
export function useCreditBillingPaths(): CreditBillingPaths {
  const { user } = useAuth();
  return isMasterContext(user)
    ? {
        billing: navigation.masterAccountBilling(),
        transactions: navigation.masterAccountCreditTransactions()
      }
    : {
        billing: navigation.settings('subscription'),
        transactions: navigation.creditTransactions()
      };
}
